module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "frontmatter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Breakthrough began as a casual glance at an article in "), _c('em', [_vm._v("The New York Times Magazine")]), _vm._v(" in March 2003. It led to a consuming research project that would take us to medical centers, universities, libraries, archives, and other sites of significance located in twenty-five cities and towns in eight states and four countries over the course of nearly five years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Initially, our research focused on Elizabeth Hughes, but we soon discovered that she was the nucleus of a constellation of characters, each of whom was as fascinating and enigmatic as Elizabeth herself. The discovery of these new characters led inexorably to more research and more discoveries. At a certain point our biggest challenge became choosing which of the many engaging characters and stories to focus on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Eventually we decided to focus on four primary characters: Elizabeth Hughes Gossett, Frederick Grant Banting, Frederick Madison Allen, and George Henry Alexander Clowes. It was particularly difficult to relegate the captivating personality of Charles Evans Hughes to secondary importance. The remarkable J. K. Lilly Sr., along with his sons Eli Lilly Jr. and J. K. Lilly Jr., also introduced tangential story lines that were hard to resist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This book is based on a true story, and relies heavily on primary historical sources and documents. With one exception, detailed in the section "), _c('em', [_vm._v("Notes and Sources,")]), _vm._v(" all characters are historical figures. Most dialogue and incidents have been drawn from contemporaneous sources, but in some cases have been invented or augmented for narrative purposes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209422b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0